<template>
  <modal
    class="likes"
    :name="'likes-modal' + postId"
    width="90%"
    height="90%"
  >
    <Button
      class="close"
      @click.native="$modal.hide('likes-modal' + postId)"
      margin="10px"
      color="#31b9be"
      bgcolor="transparent"
      width="30px"
      padding="0"
      icon="close-blue"
    ></Button>
    <h3>{{ $t("general.feed.like.likes") }}</h3>
    <ul>
      <li v-for="like in likes" :key="like.id">
        "{{ like.user.nickName ? like.user.nickName : "" }}" -
        {{ like.user.firstName }}
        {{ like.user.lastName }}
      </li>
    </ul>
  </modal>
</template>

<script>
export default {
  name: "LikedModal",
  props: {
    postId: { required: true },
    likes: { required: true }
  }
};
</script>

<style scoped>
ul {
  flex-direction: column;
  display: flex;
}

li {
  padding: 1rem 0rem;
}

ul :not(:last-child) {
  border-bottom: 1px solid #31b9be;
}

h3 {
  margin-right: 20px;
}
</style>
